/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CostingOptions } from "./CostingOptions";
import {
  CostingOptionsFromJSON,
  CostingOptionsFromJSONTyped,
  CostingOptionsToJSON,
  CostingOptionsToJSONTyped,
} from "./CostingOptions";
import type { Coordinate } from "./Coordinate";
import {
  CoordinateFromJSON,
  CoordinateFromJSONTyped,
  CoordinateToJSON,
  CoordinateToJSONTyped,
} from "./Coordinate";
import type { NearestRoadsCostingModel } from "./NearestRoadsCostingModel";
import {
  NearestRoadsCostingModelFromJSON,
  NearestRoadsCostingModelFromJSONTyped,
  NearestRoadsCostingModelToJSON,
  NearestRoadsCostingModelToJSONTyped,
} from "./NearestRoadsCostingModel";

/**
 *
 * @export
 * @interface NearestRoadsRequest
 */
export interface NearestRoadsRequest {
  /**
   *
   * @type {Array<Coordinate>}
   * @memberof NearestRoadsRequest
   */
  locations: Array<Coordinate>;
  /**
   *
   * @type {NearestRoadsCostingModel}
   * @memberof NearestRoadsRequest
   */
  costing?: NearestRoadsCostingModel;
  /**
   *
   * @type {CostingOptions}
   * @memberof NearestRoadsRequest
   */
  costingOptions?: CostingOptions;
  /**
   *
   * @type {boolean}
   * @memberof NearestRoadsRequest
   */
  verbose?: boolean;
}

/**
 * Check if a given object implements the NearestRoadsRequest interface.
 */
export function instanceOfNearestRoadsRequest(
  value: object,
): value is NearestRoadsRequest {
  if (!("locations" in value) || value["locations"] === undefined) return false;
  return true;
}

export function NearestRoadsRequestFromJSON(json: any): NearestRoadsRequest {
  return NearestRoadsRequestFromJSONTyped(json, false);
}

export function NearestRoadsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NearestRoadsRequest {
  if (json == null) {
    return json;
  }
  return {
    locations: (json["locations"] as Array<any>).map(CoordinateFromJSON),
    costing:
      json["costing"] == null
        ? undefined
        : NearestRoadsCostingModelFromJSON(json["costing"]),
    costingOptions:
      json["costing_options"] == null
        ? undefined
        : CostingOptionsFromJSON(json["costing_options"]),
    verbose: json["verbose"] == null ? undefined : json["verbose"],
  };
}

export function NearestRoadsRequestToJSON(json: any): NearestRoadsRequest {
  return NearestRoadsRequestToJSONTyped(json, false);
}

export function NearestRoadsRequestToJSONTyped(
  value?: NearestRoadsRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    locations: (value["locations"] as Array<any>).map(CoordinateToJSON),
    costing: NearestRoadsCostingModelToJSON(value["costing"]),
    costing_options: CostingOptionsToJSON(value["costingOptions"]),
    verbose: value["verbose"],
  };
}
